import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '@/components/Sidebar/Sidebar';
import Header from '@/components/Header/Header';

// Theme, document direction, and the app-wide Toaster are applied in App
// so the standalone auth pages get them too.
const AuthenticatedLayout = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className='app-shell'>
      <Header collapsed={collapsed} />
      <div className='app-shell__body'>
        <Sidebar collapsed={collapsed} onToggleCollapse={() => setCollapsed((c) => !c)} />
        <main className='app-shell__content'>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AuthenticatedLayout;
